import type { ExteriorWallQuoteFormInput } from 'app/home/create-quote/forms/property-details/exterior-wall/exterior-wall.types';
import type { QuoteDraftSelectorState } from 'app/home/global-store/quote-draft';
import type { QuoteFormOptionsSelectorState } from 'app/home/global-store/quote-form-options';

export function exteriorWallQuoteFormSelector(store: QuoteDraftSelectorState): ExteriorWallQuoteFormInput {
  const exteriorWall = store.exteriorWall();
  return { exteriorWall };
}

export function exteriorWallQuoteFormOptionsSelector(store: QuoteFormOptionsSelectorState) {
  return store['exterior-wall']();
}
